<template>
  <div class="p-pegas">
    <div
      class="card-table"
      :class="mode ? 'card__tableday' : 'card__tablenight'"
    >
      <div class="card-table-body ifon-add-title-block">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="caz-blocks-sarcho-title">
              <div
                :class="mode ? 'content__titleday' : 'content__titlenight'"
                class="content-title d-flex align-center mr-2"
              >
                {{ $t("message.client_transport") }}
              </div>
              <div class="block-sarche">
                <div class="header__search">
                  <crm-input
                    :size="'small'"
                    :className="'w100'"
                    :class="mode ? 'input__day' : 'input__night'"
                    v-model="filterForm.search"
                    :icon="'el-icon-search'"
                    class="mr-2"
                  ></crm-input>
                </div>
              </div>
            </div>
          </el-col>

          <el-col :span="12" class="flex-style text-right">
            <crm-create-and-column-settings
              :can_create="true"
              :permission="$options.name"
              :class="mode ? 'button__settingsday' : 'button__settingsnight'"
              @c-create="dialogCreate = true"
              :columns="columns"
              @c-change="updateColumn"
              :v_can_create="'guest_cars.create'"
            >
            </crm-create-and-column-settings>
          </el-col>
        </el-row>
      </div>
      <!-- end ifon-add-title-block -->

      <div class="card-table-header table-crm-smart">
        <table
          class="table-my-code table-bordered"
          v-loading="loadingData"
          :class="mode ? 'table__myday' : 'table__mynight'"
        >
          <thead>
            <tr>
              <th class="w50p" v-if="columns.id.show">
                {{ columns.id.title }}
              </th>

              <th v-if="columns.number.show">
                {{ columns.number.title }}
              </th>
              <th v-if="columns.model.show">
                {{ columns.model.title }}
              </th>
              <th v-if="columns.color.show">
                {{ columns.color.title }}
              </th>
              <th v-if="columns.guest.show">
                {{ columns.guest.title }}
              </th>
              <th v-if="columns.total_visit.show">
                {{ columns.total_visit.title }}
              </th>
              <th v-if="columns.created_at.show">
                {{ columns.created_at.title }}
              </th>
              <th v-if="columns.updated_at.show">
                {{ columns.updated_at.title }}
              </th>

              <th v-if="columns.settings.show">
                {{ columns.settings.title }}
              </th>
            </tr>

            <tr class="filter_sorche">
              <th v-if="columns.id.show">
                <el-input
                  clearable
                  size="mini"
                  v-model="filterForm.id"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  :placeholder="columns.id.title"
                  class="id_input"
                ></el-input>
              </th>

              <th v-if="columns.number.show">
                <crm-input
                  clearable
                  size="mini"
                  v-model="filterForm.number"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  :placeholder="columns.number.title"
                ></crm-input>
              </th>
              <th v-if="columns.model.show">
                <select-guest-car-model
                  size="mini"
                  :id="filterForm.guest_car_model_id"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.guest_car_model_id"
                ></select-guest-car-model>
              </th>
              <th v-if="columns.color.show">
                <crm-input
                  clearable
                  size="mini"
                  v-model="filterForm.color"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  :placeholder="columns.color.title"
                ></crm-input>
              </th>
              <th v-if="columns.guest.show">
                <select-guest
                  size="mini"
                  :id="filterForm.guest_id"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.guest_id"
                ></select-guest>
              </th>
              <th v-if="columns.total_visit.show">
                <crm-input
                  :disabled="true"
                  clearable
                  size="mini"
                  v-model="filterForm.total_visit"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  :placeholder="columns.total_visit.title"
                ></crm-input>
              </th>

              <th v-if="columns.created_at.show">
                <crm-date-picker
                  :placeholder="columns.created_at.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.created_at"
                  size="mini"
                >
                </crm-date-picker>
              </th>
              <th v-if="columns.updated_at.show">
                <crm-date-picker
                  :placeholder="columns.updated_at.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.updated_at"
                  size="mini"
                >
                </crm-date-picker>
              </th>

              <th class="settinW" v-if="columns.settings.show"></th>
            </tr>
          </thead>

          <transition-group name="flip-list" tag="tbody">
            <tr
              v-for="car in list"
              :key="car.id"
              class="cursor-pointer"
              @dblclick="edit(car)"
            >
              <td v-if="columns.id.show">{{ car.id }}</td>
              <td v-if="columns.number.show">
                {{ car.number }}
              </td>
              <td v-if="columns.model.show">
                {{ car.model }}
              </td>
              <td v-if="columns.color.show">
                {{ car.color }}
              </td>
              <td v-if="columns.guest.show">{{ car.guest }}</td>
              <td v-if="columns.total_visit.show">{{ car.total_visit }}</td>
              <td v-if="columns.created_at.show">{{ car.created_at }}</td>
              <td v-if="columns.updated_at.show">{{ car.updated_at }}</td>
              <td v-if="columns.settings.show" class="settings-td">
                <crm-settings
                  :name="$options.name"
                  :model="car"
                  :actions="actions"
                  :permissionShow="'guest_cars.update'"
                  :permissionDestroy="'guest_cars.destroy'"
                  @edit="edit"
                  @delete="destroy"
                ></crm-settings>
              </td>
            </tr>
          </transition-group>
        </table>
        <div class="my___pagination">
          <crm-pagination
            @c-change="updatePagination"
            :class="mode ? 'pagination__day' : 'pagination__night'"
            :pagination="pagination"
          ></crm-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogCreate"
      width="40%"
      :append-to-body="true"
      center
      ref="dialogCreate"
      :title="$t('message.add_car')"
      :class="mode ? 'dialog__myday' : 'dialog__mynight'"
    >
      <crm-car-create
        :guest_id="form.guest_id"
        ref="dialogCreateChild"
        dialog="dialogCreate"
      ></crm-car-create>
    </el-dialog>
    <el-drawer
      :visible.sync="drawerUpdate"
      :with-header="false"
      ref="drawerUpdate"
      size="70%"
      @opened="drawerOpened('drawerUpdateChild')"
      @closed="drawerClosed('drawerUpdateChild')"
      :class="mode ? 'dialog__myday' : 'dialog__mynight'"
    >
      <crm-show-details
        :selectedItem="selectedItem"
        ref="drawerUpdateChild"
        drawer="drawerUpdate"
      ></crm-show-details>
    </el-drawer>
  </div>
</template>

<script>
import CrmShowDetails from "./components/crm-show-details";
import selectGuest from "@/components/filters/inventory/select-guest";
import selectStaff from "@/components/filters/inventory/select-staff";
import selectGuestCarModel from "@/components/filters/inventory/select-guest-car-model";
import CrmCarCreate from "./components/car/crm-car-create";
import list from "@/utils/mixins/list";
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  mixins: [list],
  name: "GuestCarController",
  components: {
    selectGuest,
    selectStaff,
    selectGuestCarModel,
    CrmShowDetails
  },
  data() {
    return {
      drawer: false,
      dialogCreate: false,
      currentPage2: 5,
      checkList: [],
      form: {},
      sarcheBlocks: ""
    };
  },
  components: {
    CrmCarCreate
  },
  computed: {
    ...mapGetters({
      list: "guestCar/list",
      columns: "guestCar/columns",
      pagination: "guestCar/pagination",
      statues: "guestCar/statues",
      filter: "guestCar/filter",
      sort: "guestCar/sort",
      mode: "MODE"
    }),
    actions: function() {
      return ["delete"];
    }
  },
  methods: {
    ...mapActions({
      updateList: "guestCar/index",
      setPagination: "guestCar/setPagination",
      updateSort: "guestCar/updateSort",
      updateFilter: "guestCar/updateFilter",
      updateColumn: "guestCar/updateColumn",
      updatePagination: "guestCar/updatePagination",
      show: "guestCar/show",
      empty: "guestCar/empty",
      delete: "guestCar/destroy",
      refreshData: "guestCar/refreshData"
    }),
    openDrawer() {
      this.appModal = !this.appModal;
    }
  }
};
</script>
